import React from "react";
import { ASSETS_URL } from "../../utils/config";

const EmployeeCard = ({ employee }: any) => {
  return (
    <div
      key={employee.id}
      className="bg-white rounded-2xl sm:rounded-3xl transition-all duration-300 transform hover:-translate-y-1 sm:hover:-translate-y-2 xl:border-r-8 lg:border-r-8 sm:border-r-6 md:border-r-8 border-b-4 sm:border-b-6 md:border-b-8 border-navgreen overflow-visible shadow-[0px_0px_4px_0px_#00000040] hover:shadow-xl w-full h-auto min-w-0"
    >
      <div className="p-3 xs:p-4 sm:p-5 md:p-6 lg:p-5 xl:p-6 text-center h-full flex flex-col justify-between">
        {/* Profile Image */}
        <div className="relative mb-2 sm:mb-2 lg:mb-1 xl:mb-2">
          <div className="w-16 h-16 xs:w-20 xs:h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-24 lg:h-24 xl:w-28 xl:h-28 mx-auto rounded-full overflow-hidden">
            <img
              src={`${ASSETS_URL}${employee?.profilePic}`}
              alt={employee.name}
              className="h-full w-full object-cover"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                  employee.name
                )}&background=22c55e&color=ffffff&size=128&font-size=0.5`;
              }}
            />
          </div>
        </div>

        {/* Employee Info */}
        <div className="space-y-1 sm:space-y-2 lg:space-y-3 xl:space-y-2 justify-items-center justify-center">
          {/* Name */}
          <p className="text-xs xs:text-sm sm:text-xl md:text-xl lg:text-xl xl:text-xl font-semibold text-black break-words overflow-hidden">
            {employee.name}
          </p>

          {/* Position */}
          <p className="text-xs xs:text-xs sm:text-sm md:text-base lg:text-xs xl:text-base font-medium text-deepTeal break-words overflow-hidden">
            {employee.designation}
          </p>

          {/* Email */}
          <p className="text-xs xs:text-xs sm:text-sm md:text-base lg:text-xs xl:text-base font-medium text-deepTeal break-words overflow-hidden">
            <div className="flex items-center"> 

            <img src="assets/email.svg" alt="Email" className="inline-block mr-2 h-3 lg:h-4 xl:h-4 w-auto" />
            {employee.email}
            </div>
          </p>

          {/* Phone */}
          <p className="text-xs xs:text-xs sm:text-sm md:text-base lg:text-xs xl:text-base font-medium text-deepTeal break-words overflow-hidden">
            <div className="flex items-center"> 
              <img src="assets/call-regular.svg" alt="Phone" className="inline-block mr-2 h-4 lg:h-5 xl:h-5 w-auto" />
              {employee.mobileNumber}
            </div>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmployeeCard;